module.exports = __webpack_public_path__ + "toGroom-we-g-g.ba3662f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-we-g-g.jpg
// module id = xLjG
// module chunks = 0